// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"488e41d6","239":"e39fb35b","849":"312f3c4a","977":"240addac"}[chunkId] + ".chunk.js";
};